"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lines_1 = require("../lines");
var PrePaymentLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(PrePaymentLineResource, _super);
    function PrePaymentLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrePaymentLineResource.endpoint = '/lines/pp';
    PrePaymentLineResource.MODEL_NAME = 'prepaymentline';
    return PrePaymentLineResource;
}(lines_1.BaseLineResource));
exports.default = PrePaymentLineResource;
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/pp/lines.js
// module id = KB4a
// module chunks = 0